module.exports = __webpack_public_path__ + "static/media/observacion-segura.39ca090d.png";